type Record = {
  uuid: string;
};

export function findMatchingRecord<T extends Record>(
  records: (T | null)[] | undefined,
  uuid: string
): T | null | undefined {
  return findMatching(records, uuid, 'uuid');
}

/**
 * Finds the first element in records with the field value match
 */
export function findMatching<T, K extends keyof T>(
  records: (T | null)[] | undefined,
  value: T[K],
  field: K
): T | null | undefined {
  if (records) {
    return records.find((r: T | null) => !!r && r[field] === value);
  }
}

export function findMatchingRecordIndex<T extends Record>(
  records: (T | null)[],
  uuid: string
): number | undefined {
  if (records) {
    return records.findIndex((r: T | null) => !!r && r.uuid === uuid);
  }
}
